/**
 * Klarna payment method - uses shared BNPL factory.
 */

import {
  type BnplCheckoutResponse,
  type BnplCustomerInfo,
  type BnplSubmitOptions,
  createBnplPaymentMethod,
} from "./bnpl-shared";

export type KlarnaCustomerInfo = BnplCustomerInfo;

export type KlarnaSubmitOptions = BnplSubmitOptions;

export type KlarnaCheckoutResponse = BnplCheckoutResponse;

const KlarnaPaymentMethod = createBnplPaymentMethod({
  name: "klarna",
  endpointPath: "klarna",
  supportsSetupFutureUsage: true,
});

export default KlarnaPaymentMethod;
